export const translations = {
  en: {
    heading: 'Articles & News',
  },
  ge: {
    heading: 'Artikel & News',
  },
};
